// Shared by the entry point without loading API clients or analytics.
export const USER_STORAGE_KEY = 'caloriescience_user';
export const USER_PROFILE_UPDATED_EVENT = 'caloriescience:user-profile-updated';
